import { Route }       from 'react-router-dom';
import DemandList      from './views/DemandList';
import DemandDashboard from './views/DemandDashboard';

export default [
  <Route element={<DemandList />} key="list" path="/salons/:showId/demandes" />,
  <Route element={<DemandDashboard />} key="show" path="/demandes/:id" />,
];
